import {Injectable, signal} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {BaseEntity} from 'shared/models/BaseEntity';
import {
  AboutRecordDialogComponent,
} from 'shared/components/about-record-dialog/about-record-dialog.component';
import {TableColumn} from 'shared/models/TableColumn';

@Injectable({
  providedIn: 'root',
})
export class AboutRecordDialogService {
  private readonly activeRecord = signal<BaseEntity | null>(null);
  private readonly entityLabel = signal<string | undefined>(undefined);
  private readonly tableColumns = signal<TableColumn[] | undefined>(undefined);

  constructor(private readonly dialog: MatDialog) {
  }

  get active(): boolean {
    return !!this.activeRecord();
  }

  trackRecord<T extends BaseEntity>(record: T | null, entityLabel?: string, columns?: TableColumn[]): void {
    this.activeRecord.set(record);
    if (!record) {
      return;
    }

    this.entityLabel.set(entityLabel);
    this.tableColumns.set(columns);
  }

  open(record?: BaseEntity): void {
    const entity = record ?? this.activeRecord();
    if (!entity) {
      return;
    }

    this.dialog.open(AboutRecordDialogComponent, {
      width: '800px',
      data: {
        entity,
        entityLabel: this.entityLabel(),
        tableColumns: this.tableColumns(),
      },
      autoFocus: false,
    });
  }
}

